<template>
  <component :is="isMobile ? 'AIMemberWap' : 'AIMemberWeb'" />
</template>

<script>
import AIMemberWeb from './AIMemberWeb.vue'
import AIMemberWap from './AIMemberWap.vue'

import { mapState } from 'vuex'
import utils from '@/util'

export default {
  name: 'AIMember',

  components: {
    AIMemberWeb,
    AIMemberWap
  },

  computed: {
    ...mapState(['isMobile'])
  },

  mounted () {
    utils.weixinshare({
      title: '只为AI·暖冬计划',
      desc: '极客俱乐部成立。TGO鲲鹏会、极客俱乐部、极客时间VIP助力技术人掌握 AI 技能。',
      imgUrl: 'https://static001.geekbang.org/resource/image/2b/c8/2b8b3faf4bc3aa92eyyce500d295cac8.jpg'
    })
  }
}
</script>

<style lang="scss" module>
</style>
